export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const damp = (current, target, rate, dt) =>
  current + (target - current) * (1 - Math.exp(-rate * dt));

export const distance3 = (a, b) =>
  Math.hypot(a.x - b.x, a.y - b.y, a.z - b.z);

export const normalizeAngle = (angle) =>
  Math.atan2(Math.sin(angle), Math.cos(angle));
